<template>
    <div class="validate-button" :class="{'success-button':verifiable}">
        <slot></slot>
        <i v-if='loading' class="el-icon-loading"></i>
    </div>
</template>

<script>
export default {
    name:'validate-button',
    props:{
        verifiable:{ //可不可以校验
            require:false,
            type:Boolean,
            default:true
        },
        loading:{
            require:false,
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
        }
    },
    mounted(){
    },
    methods:{
    }

}
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.validate-button{
    cursor:pointer;
    height: 48px;
    background: #b7b2ae;
    border-radius: 4px;
    display: inline-flex;
    padding: 0 20px;
    align-items: center;
    justify-content: center;
    color: #fff;
    pointer-events: none;
    span{
        font-size: 14px;
        color: #FFFFFF;
        line-height: 20px;
    }
    i{
        margin-top: 2px;
        margin-left: 2px;
    }
}
.success-button{
    background: #f48c06;
    pointer-events: auto !important;
}
</style>